<app-protected-content [requiredRoles]="requiredRoles" [requireApprovedOrganization]="true">
  @let data = (data$ | async) || [];
  @let columns = (columnConfig$ | async) || [];
  @let totalElements = (totalElements$ | async) || 0;
  @let queryParams = (queryParams$ | async);
  <htx-table
    [data]="data"
    [columns]="columns"
    [enablePagination]="true"
    [pageSize]="queryParams?.size || 5"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [totalItems]="totalElements"
    [disableClientFiltering]="true"
    emptyMessage="partnernetwork.overview.noRequests"
    (pageChanged)="onPageChange($event)"
    (sortChanged)="onSortChange($event)"
    (filterChanged)="onFilterChange($event)">
  </htx-table>

  <ng-template #columnStatus let-row>
    @let organization = getTyped(row);
    @let status = organization.activityState;
    <htx-badge
      [text]="'organization.control.activityState.options.' + status | transloco"
      [variant]="status === ActivityState.ACTIVE ? 'success' : 'danger'">
    </htx-badge>
  </ng-template>

  <ng-template #columnActions let-row>
    @let organization = getTyped(row);
    <div class="action-buttons">
      <htx-button variant="primary" icon="visibility" [iconOnly]="true" tooltip="Anzeigen" (click)="goToDetails(organization)"></htx-button>
    </div>
  </ng-template>
</app-protected-content>
